/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export { RollupFormBase as RollupForm } from './RollupForm.base.js'
